/* libraries */
import riot from 'riot';

/* custom tags */
import './world-map.tag.es6.js';

/* bootstrapping */
riot.mount('body', 'world-map');



/** WEBPACK FOOTER **
 ** ./src/index.es6.js
 **/